module.exports = __webpack_public_path__ + "img/ag-island2.a350a231.png";